var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.83203H6.6775M11 7.83203H11.0108M15.3333 7.83203H15.3442M7.75 14.332H3.41667C2.84203 14.332 2.29093 14.1038 1.8846 13.6974C1.47827 13.2911 1.25 12.74 1.25 12.1654V3.4987C1.25 2.92406 1.47827 2.37296 1.8846 1.96663C2.29093 1.5603 2.84203 1.33203 3.41667 1.33203H18.5833C19.158 1.33203 19.7091 1.5603 20.1154 1.96663C20.5217 2.37296 20.75 2.92406 20.75 3.4987V12.1654C20.75 12.74 20.5217 13.2911 20.1154 13.6974C19.7091 14.1038 19.158 14.332 18.5833 14.332H13.1667L7.75 19.7487V14.332Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.9ee90ea2d3bba646093396d822da9354.svg";
export { ForwardRef as ReactComponent };